import * as React from 'react';
import { InjectedIntlProps, injectIntl } from 'react-intl';
import { ErrorType } from '../../../../../../domain/entities/Auth';
import { CreateUserQuery } from '../../../../../../infrastructure/repositories/AuthRepository';
import PurchaseSubmitButton from '../../common/buttons/PurchaseSubmitButton';
import PurchaseTextInput, {
  TextInputType,
} from '../../common/forms/PurchaseTextInput';
import PurchaseLabeledContainer from '../../common/PurchaseLabeledContainer';
import PurchaseCreateUserConfirmAlert from '../../common/texts/PurchaseCreateUserConfirmAlert';
import * as $ from '../../helper';
import ErrorMessage from './ErrorMessage';

interface Props {
  postable: boolean;
  onSubmit: (query: CreateUserQuery) => void;
  errors?: ErrorType[];
}

interface Control {
  submittable?: boolean;
}

interface State {
  lastName: string;
  firstName: string;
  email: string;
  password: string;
  control: Control;
}

class InputCreateUser extends React.Component<
  Props & InjectedIntlProps,
  State
> {
  constructor(props: Props & InjectedIntlProps) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    const _state: State = {
      lastName: '',
      firstName: '',
      email: '',
      password: '',
      control: {},
    };
    this.state = {
      ..._state,
      control: this.createControl(_state),
    };
  }

  private createControl(state: State): Control {
    const { control } = state;
    control.submittable =
      $.getValueByNestedString(state, 'lastName') &&
      $.getValueByNestedString(state, 'firstName') &&
      $.getValueByNestedString(state, 'email') &&
      $.getValueByNestedString(state, 'password');
    return control;
  }

  private handleChange(e: React.ChangeEvent<HTMLInputElement>) {
    const {
      currentTarget: { name, value },
    } = e;
    const changedState = $.changeObjectByNestedString(this.state, name, value);
    this.setState({
      ...changedState,
      control: this.createControl(changedState as State),
    });
  }

  private async handleSubmit() {
    const { lastName, firstName, email, password } = this.state;
    this.props.onSubmit({ lastName, firstName, email, password });
  }

  public render() {
    const { postable, intl, errors } = this.props;
    const {
      control: { submittable },
    } = this.state;

    return (
      <div>
        <PurchaseLabeledContainer
          label={intl.formatMessage({
            id: 'purchases.inputCreateUser.lastName',
          })}
          paddingTop={true}
        >
          <PurchaseTextInput
            type={TextInputType.Text}
            name={'lastName'}
            value={this.state.lastName}
            onChange={this.handleChange}
          />
        </PurchaseLabeledContainer>
        <PurchaseLabeledContainer
          label={intl.formatMessage({
            id: 'purchases.inputCreateUser.firstName',
          })}
          paddingTop={true}
        >
          <PurchaseTextInput
            type={TextInputType.Text}
            name={'firstName'}
            value={this.state.firstName}
            onChange={this.handleChange}
          />
        </PurchaseLabeledContainer>
        <PurchaseLabeledContainer
          label={intl.formatMessage({
            id: 'purchases.inputCreateUser.email',
          })}
          paddingTop={true}
        >
          <PurchaseTextInput
            type={TextInputType.Email}
            name={'email'}
            value={this.state.email}
            onChange={this.handleChange}
          />
        </PurchaseLabeledContainer>
        <PurchaseLabeledContainer
          label={intl.formatMessage({
            id: 'purchases.inputCreateUser.password',
          })}
        >
          <PurchaseTextInput
            type={TextInputType.Password}
            name={'password'}
            value={this.state.password}
            onChange={this.handleChange}
            placeholder={intl.formatMessage({
              id: 'purchases.inputCreateUser.passwordPlaceholder',
            })}
          />
        </PurchaseLabeledContainer>
        <ErrorMessage errors={errors} />
        <PurchaseCreateUserConfirmAlert />
        <PurchaseSubmitButton
          type="button"
          onClick={this.handleSubmit}
          value={intl.formatMessage({
            id: 'purchases.inputCreateUser.submitButton',
          })}
          disabled={!submittable || !postable}
          postable={postable}
        >
          {intl.formatMessage({ id: 'purchases.inputCreateUser.submitButton' })}
        </PurchaseSubmitButton>
      </div>
    );
  }
}

export default injectIntl(InputCreateUser);
